// extracted by mini-css-extract-plugin
export var chevron = "_l1-3";
export var chevronRotated = "_l1-4";
export var image = "_l1-1";
export var imageContainer = "_l1-0";
export var shippingAddress = "_l1-2";